import { unauthenticatedClient } from './baseApi';

export interface ChamaConfig {
  id: number;
  name: string;
  chama_type: 'merry_go_round' | 'investment' | 'welfare' | 'loan' | 'rotating_business' | 'hybrid';
  contribution_frequency: 'daily' | 'weekly' | 'biweekly' | 'monthly' | 'quarterly' | 'custom';
  contribution_amount: number;
  penalty_per_day: number;
  contribution_start: number;
  contribution_end: number;
  payout_day: number;
  current_cycle: number;
  cycle_state: 'setup' | 'collecting' | 'payout_ready' | 'cycle_active' | 'paused';
  contributions_open: boolean;
  rotation_order: number[];
  is_active: boolean;
  updated_at: string;
}

export const PublicApi = {
  async getPublicConfig(): Promise<ChamaConfig> {
    const response = await unauthenticatedClient.get<{ config: ChamaConfig }>('/public/config');
    return response.data.config;
  },
};

export default PublicApi;

